export function CompanyLogo({ company, size = "md", className = "" }) {
  const sizes = { sm: "w-8 h-8 text-lg", md: "w-12 h-12 text-2xl", lg: "w-20 h-20 text-4xl", xl: "w-28 h-28 text-6xl" };
  if (!company) return null;
  if (company.logo_url) {
    return (
      <span data-testid="company-logo-img" className={`${sizes[size]} grid place-items-center rounded-xl bg-white overflow-hidden border border-border ${className}`}>
        <img src={company.logo_url} alt={company.name} className="w-full h-full object-contain p-1" />
      </span>
    );
  }
  return (
    <span data-testid="company-logo-emoji" className={`${sizes[size]} grid place-items-center rounded-xl ${className}`} style={{ background: `${company.color || "#2563EB"}18` }}>
      {company.logo}
    </span>
  );
}
